<script setup lang="ts">
import { Input } from '@/components/ui/input'

defineProps<{ modelValue: string; id?: string; autocomplete?: string; invalid?: boolean }>()
defineEmits<{ 'update:modelValue': [string] }>()
</script>

<template>
  <div class="flex">
    <span
      class="border-input bg-muted text-muted-foreground flex items-center rounded-l-md border border-r-0 px-3 text-sm font-medium select-none"
    >
      +61
    </span>
    <Input
      :id="id"
      :model-value="modelValue"
      :autocomplete="autocomplete ?? 'tel'"
      :class="['rounded-l-none', invalid && 'border-destructive focus-visible:ring-destructive']"
      type="tel"
      placeholder="0412 345 678"
      maxlength="13"
      pattern="04[0-9 ]{8,11}"
      title="Must start with 04 and be 10 digits"
      @update:model-value="$emit('update:modelValue', $event as string)"
    />
  </div>
</template>
